import React, {useState} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSearch, faPen} from '@fortawesome/free-solid-svg-icons';
import {push} from 'connected-react-router';

import {AppState} from '../Store';
import {Article} from '../Services/ArticleService';
import {ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';

import CategoryLink from '../Components/CategoryLink';
import {
  setSearchCreator,
  pushHomeCreator,
} from '../Store/Home/Actions';

interface HeaderProps {
  article?: Article;
  categories: string[];
  pathname: string;
  getLink: (id: number) => string;
  admin: boolean;

  performSearch: (category: string) => Promise<void>;
  pushHome: () => Promise<void>;
  push: (path: string) => void;
}

function Header({
  article,
  categories,
  pathname,
  getLink,
  admin,

  performSearch,
  pushHome,
  push,
}: HeaderProps) {
  const [search, setSearch] = useState('');

  let articleHeader = undefined;
  if (article !== undefined) {
    const bgStyle = {
      backgroundImage: `url(${getLink(article.image)})`,
    };

    articleHeader = (
      <div className="hero-area height-400 bg-img background-overlay" style={bgStyle}>
        <div className="container h-100">
          <div className="row h-100 align-items-center justify-content-center">
            <div className="col-12 col-md-8 col-lg-6">
              <div className="single-blog-title text-center">
                <div className="post-cta">
                  {article.categories.map(cat => {
                    return <CategoryLink key={cat} category={cat} />;
                  })}
                </div>
                <h3>
                  {article.title}
                  {admin
                    ? (
                      <Link to={`/admin/articles/${article.id}`}>
                        {' '}
                        <FontAwesomeIcon icon={faPen} />
                      </Link>
                    ) : null
                  }
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const searchChanged = (e: React.FormEvent<HTMLInputElement>) => {
    setSearch(e.currentTarget.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== 'Enter') {
      return;
    }

    performSearch(search);
  };

  const searchClick = (e: React.FormEvent<HTMLButtonElement>) => {
    e.preventDefault();
    performSearch(search);
  };

  const homeClick = (e: React.MouseEvent) => {
    e.preventDefault();
    pushHome();
  };

  const logoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (admin) {
      push('/admin');
    } else {
      pushHome();
    }
  };

  // this is dumb.
  const homeClass = pathname === '/public'
    ? 'tag selected'
    : 'tag';

  return (
    <div>
      <nav className="navbar nav-header">
        <div className="navbar-brand">
          <img src="/logo.png" alt="Connectx News" onClick={logoClick} />
        </div>
        <div className="form-inline">
          <div className="input-group mb-3">
            <input className="form-control" type="search" placeholder="Search" aria-label="Search" onChange={searchChanged} onKeyDown={handleKeyDown} />
            <div className="input-group-append">
              <button className="btn btn-outline-success" type="submit" onClick={searchClick}><FontAwesomeIcon icon={faSearch} /></button>
            </div>
          </div>
        </div>
      </nav>
      <nav className="navbar pill-nav">
        <a className={homeClass} href="/public/" onClick={homeClick}>My Feed</a>
        {categories.map(cat => {
          return <CategoryLink className="tag" key={cat} category={cat} title={true} />;
        })}
      </nav>
      {articleHeader}
    </div>
  );
}

const mapStateToProps = (state: AppState) => ({
  article: state.articles.article,
  categories: state.home.categories,
  pathname: state.router.location.pathname,
  getLink: state.auth.imageService.link,
  admin: state.auth.admin,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    performSearch: (search: string) => dispatch(setSearchCreator(search)),
    pushHome: () => dispatch(pushHomeCreator()),
    push: (path: string) => dispatch(push(path)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
